export class IndieLogin {

    private readonly BNA_COOKIE_SUCCESS = 'bna_network';
    private readonly BNA_COOKIE_ERROR = 'bna_error';
    private readonly BNA_COOKIE_VALIDATED = 'bna_network_validated';

    private readonly BNA_COOKIE_DOMAIN = process.env.VUE_APP_BNA_COOKIE_DOMAIN;
    private readonly BNA_COOKIE_PATH = '/';

    public isLoginPopup = false;

    private data: any = {
        id: false,
        first_name: "",
        last_name: "",
        email: "",
        failed_login: false,
        validated: true,
        just_validated: false,
        affiliate: false
    };

    constructor(){
        this.parseCookies();
    }

    public openLoginPopup() {
        this.isLoginPopup = !this.isLoginPopup;
    }

    logOut() {
        this.removeCookie(this.BNA_COOKIE_SUCCESS);
        setTimeout( () => location.reload(), 100 );
    }

    private removeCookie(sKey: string) {
        const date = new Date();
        date.setTime(date.getTime() + (-2 * 24 * 60 * 60 * 1000));
        let cookieString = encodeURIComponent(sKey) +
          '=; expires=' + date.toUTCString() +
          '; domain='+ this.BNA_COOKIE_DOMAIN +
          '; path='+ this.BNA_COOKIE_PATH;
        document.cookie = cookieString;
    }

    private parseCookies() {
        let cookie = document.cookie;

        let cookies = cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            let parts = cookies[i].split('=');

            if (2 == parts.length) {
                let cookie_name = this.trim(parts[0]);

                if (this.BNA_COOKIE_SUCCESS == cookie_name) {
                    let elements: any = decodeURIComponent(parts[1]).split("|");

                    if (elements.length > 6) {
                        if (!isNaN(elements[0])) {
                            this.data.id = elements[0];
                            this.data.first_name = elements[1];
                            this.data.last_name = elements[2];
                            this.data.email = elements[3];
                            this.data.validated = elements[6] == '1';
                            this.data.affiliate = elements[8] == '1';
                        }
                    }
                } else
                if (this.BNA_COOKIE_ERROR == cookie_name) {
                    this.data.failed_login = true;
                } else if (this.BNA_COOKIE_VALIDATED == cookie_name) {
                    this.data.just_validated = true;
                }
            }
        }

        if (this.isValidated() && this.justValidated()) {
            this.removeCookie(this.BNA_COOKIE_VALIDATED);
        }
    }

    private isValidated() {
        return this.data.validated;
    }

    public isAffiliate(){
        return this.data.affiliate;
    }

    private justValidated() {
        return this.data.just_validated;
    }

    public hasFailedLogin() {
        return this.data.failed_login;
    }

    public clearAuthenticationFailure(){
        this.removeCookie(this.BNA_COOKIE_ERROR);
    }

    private trim(str: string) {
        return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    public getFirstName() {
        return this.decodeHtmlEntities(this.data.first_name.replace('+', ' '));
    }

    public getLastName() {
        return this.decodeHtmlEntities(this.data.last_name.replace('+', ' '));
    }

    public getId() {
        return parseInt(this.data.id);
    }

    public getEmail() {
        return this.data.email;
    }

    public isLogged() {
        return this.data.id !== false;
    }

    private decodeHtmlEntities(str: string) {
        const elem = document.createElement('textarea');
        elem.innerHTML = str;
        return elem.value;
    }


}
